import { MOOD_META } from "../lib/moods";

export default function MoodCard({ moodKey, mood, selected, onClick }) {
  const meta = MOOD_META[moodKey] || {};
  return (
    <button
      data-testid={`mood-card-${moodKey}`}
      onClick={onClick}
      className={`group relative text-left rounded-lg p-5 overflow-hidden sp-card ${selected ? "sp-mood-active" : ""}`}
      style={{ background: selected ? "#282828" : undefined }}
    >
      <div
        className="absolute -right-6 -bottom-6 h-24 w-24 rounded-full blur-xl opacity-70"
        style={{ background: meta.color }}
      />
      <div className="relative">
        <div
          className="h-14 w-14 rounded-md flex items-center justify-center text-3xl shadow-[0_6px_20px_rgba(0,0,0,0.4)]"
          style={{ background: meta.color }}
        >
          {meta.emoji}
        </div>
        <div className="mt-4 font-extrabold text-base text-white tracking-tight">{mood.name}</div>
        <div className="text-xs text-[#B3B3B3] mt-0.5 line-clamp-2">{meta.tagline}</div>
      </div>
      {selected && (
        <div className="absolute top-3 right-3 h-6 w-6 rounded-full bg-[#FF2E93] flex items-center justify-center">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="3">
            <path d="M5 13l4 4L19 7" />
          </svg>
        </div>
      )}
    </button>
  );
}
